import React from "react";
import { Button, Checkbox, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";

import Modals from "../common/modal";
import "../../style/modules/importModal.scss";

const { Dragger } = Upload;

const ImportModal = ({
  openModal,
  setOpenModal,
  setFile,
  handleSubmit,
  loading,
  isChecked,
  setIsChecked,
  isCheckboxShow,
}) => {
  const handleFileChange = (file) => {
    setFile(file.file);
  };
  const beforeUpload = () => {
    return false;
  };

  const footerElem = [
    <div className="modal_footer">
      <Button key="submit" loading={loading || false} onClick={handleSubmit}>
        Submit
      </Button>
    </div>,
  ];

  return (
    <Modals
      open={openModal}
      setOpen={setOpenModal}
      footer={footerElem}
      width={500}
      paddingCss={"1.5rem 0 0 0 "}
    >
      <p className="import_file_title">File Upload (CSV)</p>
      <div className="import_file_dragger">
        <Dragger
          onChange={handleFileChange}
          beforeUpload={beforeUpload}
          multiple={false}
          maxCount={1}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined className="delete_icon" />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
        </Dragger>
        {isCheckboxShow ? (
          <div>
            <Checkbox
              className="checkbox_label"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            >
              Replace data
            </Checkbox>
          </div>
        ) : null}
      </div>
    </Modals>
  );
};

export default ImportModal;
